import { useQuery, UseQueryResult } from "@tanstack/react-query"
import ResponseError from "#/types/responseError"
import { ExtendedProvidersTypeaheadProvider } from "#/pages/provider-finder/types/Providers"
import { useProviderFinderClient } from "#/components/views/app/navigation/hooks/useProviderFinderClient"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"

const EXTENDED_PROVIDERS_TYPEAHEAD_QUERY_KEY = "GetExtendedProvidersTypeahead"

export function useGetExtendedProvidersTypeahead(
  providerNameSubstring: string,
  providerType?: string,
  countryCode?: string | null
): UseQueryResult<ExtendedProvidersTypeaheadProvider[], ResponseError> {
  // Use navigation hook which has mock client support
  const client = useProviderFinderClient()

  return useQuery<ExtendedProvidersTypeaheadProvider[], ResponseError>(
    [EXTENDED_PROVIDERS_TYPEAHEAD_QUERY_KEY, providerNameSubstring, providerType, countryCode],
    () => {
      if (!providerNameSubstring) {
        return null
      }

      return client.getExtendedProvidersTypeahead(providerNameSubstring, providerType, countryCode)
    },
    {
      enabled: !!providerNameSubstring,
      refetchOnWindowFocus: false,
      retry: buildCarrotApiRetryPolicy(3)
    }
  )
}
